module.exports = lincd._modules['lincd_dcmi'];